import VxeTableColumnRender from './VxeTableColumnRender.vue'
export default {
  install: function (Vue) {
    Vue.component('vxe-table-column-render', VxeTableColumnRender)
  }
}